import React from 'react';
import { connect } from 'react-redux';
import JobQuote from '../../views/Jobs/JobQuote';
import { getTerminals, createQuote, getStates, getZipCodes, getDestinations } from '../Dashboard/DashboardActions';
import { jobRequestV1, jobRequestPdf } from '../../containers/Jobs/JobsActions';
import { getAccessorials } from '../AccessorialsAndFees/AccessorialsAndFeesActions';


class JobsContainer extends React.Component {

  componentDidMount() {
    const { dispatchGetTerminals, dispatchGetAccessorials } = this.props;
    dispatchGetTerminals();
    dispatchGetAccessorials();
  }

  render() {
    const { self,
      quote, 
      jobRequest, 
      terminals, 
      accessorials, 
      dispatchJobRequest, 
      dispatchCreateQuote, 
      dispatchGetDestinations,
      dispatchGetStates,
      dispatchGetZipCodes,
      dispatchJobRequestPdf    
    } = this.props;
    return <JobQuote
      dispatchJobRequestPdf={dispatchJobRequestPdf}
      dispatchGetDestinations={dispatchGetDestinations}
      dispatchGetStates={dispatchGetStates}
      dispatchGetZipCodes={dispatchGetZipCodes}
      jobRequest={jobRequest} accessorials={accessorials} quote={quote} dispatchJobRequest={dispatchJobRequest} dispatchCreateQuote={dispatchCreateQuote} self={self} terminals={terminals} url={this.props.match} />;
  }
}


const mapStateToProps = (state) => {

  return {
    terminals: state.business.terminals,
    self: state.self,
    quote: state.business.quote,
    accessorials: state.accessorials,
    jobRequest: state.jobRequest

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchGetAccessorials: () => { dispatch(getAccessorials()); },
    dispatchGetTerminals: () => { dispatch(getTerminals()); },
    dispatchGetDestinations: (params, cb) => { dispatch(getDestinations(params, cb)) },
    dispatchGetStates: (params, cb) => { dispatch(getStates(params, cb)) },
    dispatchGetZipCodes: (params, cb) => { dispatch(getZipCodes(params, cb)) },
    dispatchCreateQuote: (params, cb) => { dispatch(createQuote(params, cb)); },
    dispatchJobRequest: (params, cb) => { dispatch(jobRequestV1(params, cb)); },
    dispatchJobRequestPdf: (params, cb) => { dispatch(jobRequestPdf(params, cb)); },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(JobsContainer);


// WEBPACK FOOTER //
// ./src/containers/Jobs/JobsContainer.js